var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7.5,
    width: 85,
    height: 85,
    rx: 42.5,
    fill: "#2C74D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.4375 65.9375L58.7344 58.2344M62.8958 48.2292C62.8958 56.0532 56.5532 62.3958 48.7292 62.3958C40.9051 62.3958 34.5625 56.0532 34.5625 48.2292C34.5625 40.4051 40.9051 34.0625 48.7292 34.0625C56.5532 34.0625 62.8958 40.4051 62.8958 48.2292Z",
    stroke: "white",
    strokeWidth: 3.54167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7.5,
    width: 85,
    height: 85,
    rx: 42.5,
    stroke: "#EEF7FE",
    strokeWidth: 14.1667
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default "data:image/svg+xml,%3csvg width='101' height='100' viewBox='0 0 101 100' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect x='8' y='7.5' width='85' height='85' rx='42.5' fill='%232C74D6'/%3e %3cpath d='M66.4375 65.9375L58.7344 58.2344M62.8958 48.2292C62.8958 56.0532 56.5532 62.3958 48.7292 62.3958C40.9051 62.3958 34.5625 56.0532 34.5625 48.2292C34.5625 40.4051 40.9051 34.0625 48.7292 34.0625C56.5532 34.0625 62.8958 40.4051 62.8958 48.2292Z' stroke='white' stroke-width='3.54167' stroke-linecap='round' stroke-linejoin='round'/%3e %3crect x='8' y='7.5' width='85' height='85' rx='42.5' stroke='%23EEF7FE' stroke-width='14.1667'/%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };